module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.2e0bf09.woff2";